import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;  
  height: auto;
  align-self: baseline;
  flex: 1;  

  .mobile & {
    padding: 0 15px;
    > span {
      font-size: 12px;
    }

    > .container-videoPlayer {
      height: initial;
      padding-bottom: 0;
    }
  }

  span {
    font-weight: 500;
    font-size: 1.2rem;
  }

  & > .container-videoPlayer {
    height: calc(100vh - 334px);
    padding-bottom: 16px;

    #player {
      height: 100%;
      width: 100%;
      margin: 1rem 0;
    }
  }
`;

export const Controls = styled.div`
  width: 100%;
  height: 3.8rem;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding-right: 1px;
  background: ${props => props.theme.colors.primary};

  .mobile & {
    height: 36px;

    span {
      font-size: 12px;
    }
  }

  span {
    font-size: 1rem;
    color: ${props => props.theme.colors.white};

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }

  img {
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }

  .disabled {
    opacity: .3 !important;
    cursor: not-allowed !important;
  }
`;
